import React from 'react';
import { MdArrowBackIos, MdArrowForwardIos } from 'react-icons/md';

const BackButton = ({ onClick, reverse }) => {
  return (
    <button
      type="button"
      className="w-7 h-7 bg-white rounded-full flex justify-center items-center shadow"
      onClick={onClick}
    >
      {reverse && <MdArrowForwardIos className="text-primary ml-[0.15rem]" size="1rem" />}
      {!reverse && <MdArrowBackIos className="text-primary ml-[0.35rem]" size="1rem" />}
    </button>
  );
};

export default BackButton;
